import { BLUE_RIBBON_INACTIVE_REASONS } from './../../../../../common/interfaces/blue-ribbon-party-jackpot.interface';
import {action, observable} from 'mobx';
import {
    BLUE_RIBBON_POT_STATE,
    IBlueRibbonJackpot
} from '../../../../../common/interfaces/blue-ribbon-party-jackpot.interface';
import {JACKPOT_STATE} from '../../../../../common/const/jackpot_map_ids';
import ServiceFactory from '../../service_factory';


export abstract class BlueRibbonJackpot implements IBlueRibbonJackpot {

    constructor(public readonly jackpotId: string, protected readonly _serviceFactory: ServiceFactory) {
    }


    @observable.ref
    private _initialValue: number = 0;
    public get initialValue(): number {
        return this._initialValue;
    }

    @action.bound
    public setInitialValue(value: number): void {
        this._initialValue = value;
    }

    @observable.ref
    private _currentValue: number = 0;
    public get currentValue(): number {
        return this._currentValue;
    }
    @action.bound
    public setCurrentValue(value: number): void {
        this._currentValue = value;
    }

    @observable.ref
    private _isOptedIn: boolean = false;
    public get isOptedIn(): boolean {
        return this._isOptedIn;
    }

    //We need this function because mobx actions cannot be overridden in derived classes.
    protected _updateIsOptedIn(value: boolean): void {
        this._isOptedIn = value;
    }

    @action.bound
    public setIsOptedIn(value: boolean): void {
        this._updateIsOptedIn(value);
    }

    @observable.ref
    protected _isActive: boolean = false;
    public get isActive(): boolean {
        return this._isActive;
    }

    @observable.ref
    protected _inactiveReason: BLUE_RIBBON_INACTIVE_REASONS = null;
    public get inactiveReason(): BLUE_RIBBON_INACTIVE_REASONS {
        return this._inactiveReason;
    }

    //We need this function because mobx actions cannot be overridden in derived classes.
    protected _updateIsActive(value: boolean, inactiveReason: BLUE_RIBBON_INACTIVE_REASONS): void {
        this._isActive = value;
        this._inactiveReason = inactiveReason ?? null;
    }
    

    @action.bound
    public setIsActive(value: boolean, inactiveReason: BLUE_RIBBON_INACTIVE_REASONS): void {
        this._updateIsActive(value, inactiveReason);
    }

    public get hasWin(): boolean {
        return this.winAmount > 0;
    }

    @observable.ref
    private _winAmount: number = 0;
    public get winAmount(): number {
        return this._winAmount;
    }

    @observable.ref
    private _winningPlayer: string = null;
    public get winningPlayer(): string {
        return this._winningPlayer;
    }

    @observable.ref
    private _winISO3Currency: string = null;
    public get winISO3Currency(): string {
        return this._winISO3Currency;
    }

    @action.bound
    public setWinAmount(currency: string, value: number, winningPlayer: string): void {
        this._winAmount = value;
        this._winISO3Currency = currency;
        this._winningPlayer = winningPlayer;
    }

    @observable.ref
    private _potState: BLUE_RIBBON_POT_STATE = "COLD";
    public get potState(): BLUE_RIBBON_POT_STATE {
        return this._potState;
    }
    @action.bound
    public setPotState(value: BLUE_RIBBON_POT_STATE): void {
        this._potState = value;
    }

    getStandardJackpotState(): JACKPOT_STATE {
        switch (this.potState) {
            case "COLD":
                return JACKPOT_STATE.Cold;
            case "CHILLY":
                return JACKPOT_STATE.Regular;
            case "WARM":
            case "HOT":
                return JACKPOT_STATE.Hot;
            default:
                return JACKPOT_STATE.Cold;
        }
    }

    get isEligible(): boolean {
        return this.isOptedIn && this.isActive && !this.hasWin;
    }

    get hasBetContributions(): boolean {
        return this.initialValue > 0
            && this.initialValue !== this.currentValue;

    }
}
